import { Menu as MenuIcon } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Logo from "../../assets/icons/images/logo.jpg";
import useApp from "../../hooks/useApp";
import { CampaignQueryParam } from "../../pages/DonationPage/const";
import { getCampaignById_V2 } from "../../Services_V2/Campaign.service";
import cn from "../../utils/cn";
import styles from "./header.module.css";

const logo = "/logo.jpg";

const Header = () => {
  const { dispatch } = useApp();
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const campaignId = searchParams.get(CampaignQueryParam.CAMPAIGN_ID);
  const [campaignLogo, setCampaignLogo] = useState<string | null>(null);

  useEffect(() => {
    const elem = document.getElementsByClassName("applayout_container")?.[0];
    const handleScroll = () => {
      if (elem.scrollTop > 70) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    if (elem) {
      elem.addEventListener("scroll", handleScroll);
    }

    return () => {
      elem.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (campaignId) {
      getCampaignById_V2(campaignId)
        .then((res) => {
          if (res?.data?.logo?.url) {
            setCampaignLogo(res.data.logo.url);
          }
        })
        .catch(console.error);
    } else {
      setCampaignLogo(null);
    }
  }, [campaignId]);

  return (
    <Box className={cn(styles.header, isSticky ? styles.sticky : "")}>
      {campaignLogo ? (
        <img
          src={campaignLogo}
          alt="Campaign Logo"
          style={{ height: "40px", objectFit: "contain", borderRadius: 8 }}
        />
      ) : (
        <img
          src={Logo}
          alt="No Image Found"
          style={{ height: "40px", objectFit: "contain", borderRadius: 8 }}
        />
      )}
      <IconButton
        onClick={() =>
          dispatch({ type: "updateState", payload: { sidebarOpen: true } })
        }
      >
        <MenuIcon sx={{ color: "#fff" }} />
      </IconButton>
    </Box>
  );
};

export default Header;
